import { render } from "./SignerProposalTable.vue?vue&type=template&id=358501bc"
import script from "./SignerProposalTable.vue?vue&type=script&lang=js"
export * from "./SignerProposalTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__